import React, { Component } from "react";
import { loading, params, mode, setDarkMode } from "../components/CustomComponent.js";
import { Navbar, Nav } from "react-bootstrap";
import LOGO from "../assets/images/logo-landscape2.png";
import TH from "../assets/images/thailand.png";
import LK from "../assets/images/laos.png";
import API from "../assets/files/api.json";
import APITH from "../assets/files/api_payment_th.json";
import APILK from "../assets/files/api_payment_lk.json";
import APIOP from "../assets/files/api_option.json";
import { SECTION_GROUPS, SECTIONS } from "./document-api/sections/index.js";
import ApiReference from "./document-api/ApiReference.js";
import { DocSection } from "./document-api/ui.js";

// endpoint พิเศษ (api_option.json) แสดงเฉพาะลิงก์ที่ส่งให้ partner บางราย
const showOptionalApis = () =>
  params("i") === "api:update-customer-batch" || params("i") === "api:verify-account" || params("type") === "special";

const API_GROUPS = () => [
  { group: "General API", items: [...API.item, ...(showOptionalApis() ? APIOP.item : [])] },
  { group: "THB Payment", flag: TH, items: APITH.item },
  { group: "LAK Payment", flag: LK, items: APILK.item },
];

export default class DocApi extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selected: params("i") || "credential-requirements",
      type: "curl",
      response_tab: 0,
      menu_open: false,
    };
  }

  async componentDidMount() {
    if (mode === "dark") {
      setDarkMode();
    }
    loading(false);
    // ?i=api:<ชื่อ endpoint ใช้ - แทนช่องว่าง> เช่น api:deposits-thai
    if (params("i")?.split(":")[0] === "api") {
      const name = params("i").split(":")[1].replaceAll("-", " ");
      const api = API_GROUPS().flatMap((g) => g.items);
      this.setState({ selected: api.find((e) => e.name.toLowerCase() === name) });
    }
  }
  async componentDidUpdate() {
    if (mode === "dark") {
      setDarkMode();
    }
  }

  isActive = (route) => (typeof route === "string" ? this.state.selected === route : this.state.selected?.name === route?.name);

  renderNavbar = (icon, name, route) => (
    <span
      key={typeof route === "string" ? route : route?.name}
      className={`doc-nav-item ${this.isActive(route) ? "active" : ""}`}
      onClick={() => {
        // มือถือ: เลือกหัวข้อแล้วปิดเมนูเอง และกลับไปบนสุดของหัวข้อใหม่
        this.setState({ selected: route, response_tab: 0, menu_open: false });
        window.scrollTo(0, 0);
      }}
    >
      <div>{name}</div>
      {icon ? <small className={`doc-method doc-method-${icon.toLowerCase()}`}>{icon}</small> : null}
    </span>
  );

  componentMenu = () => (
    <>
      {SECTION_GROUPS.map((g, index) => (
        <React.Fragment key={`section-group-${index}`}>
          {index > 0 && <hr />}
          {g.group && <div className="doc-group">{g.group}</div>}
          {g.items.map((s) => this.renderNavbar("", s.menu, s.id))}
        </React.Fragment>
      ))}
      {API_GROUPS().map((g) => (
        <React.Fragment key={`api-group-${g.group}`}>
          <hr />
          <div className="doc-group">
            {g.group}
            {g.flag && <img alt="country" src={g.flag} width="18" className="ms-2" />}
          </div>
          {g.items.map((item) => this.renderNavbar(item.request.method, item.name, item))}
        </React.Fragment>
      ))}
    </>
  );

  render() {
    const { selected, type, response_tab, menu_open } = this.state;
    const section = typeof selected === "string" ? SECTIONS[selected] : null;
    return (
      <div className="w-100 min-vh-100 doc-scope">
        {/* SIDEBAR */}
        <div className="hpx-50">
          <Navbar
            className="px-3 px-xl-4 doc-topbar position-fixed w-100"
            expanded={menu_open}
            onToggle={(open) => this.setState({ menu_open: open })}
            style={{ zIndex: 1000 }}
            expand="xl"
          >
            <Navbar.Brand href="/" className="fw-bold text-dark">
              <div className="position-relative">
                <img
                  alt="logo"
                  src={LOGO}
                  height={35}
                  style={{ objectFit: "contain" }}
                  className="pointer"
                  onClick={() => {
                    window.location.href = "/";
                  }}
                />
                <span className="position-absolute" style={{ right: 8, bottom: -4, fontSize: 10, color: "#dabb55" }}>
                  v {global.version}
                </span>
              </div>
            </Navbar.Brand>
            <Navbar.Toggle className="border-0" aria-controls="basic-navbar-nav" />
            <Navbar.Collapse id="basic-navbar-nav" className="overflow-auto">
              <Nav className="ms-auto">
                <div className="d-block d-xl-none mb-5 pt-4" style={{ height: "80vh" }}>
                  {this.componentMenu()}
                </div>
              </Nav>
            </Navbar.Collapse>
          </Navbar>
          <div
            className="position-fixed wpx-260 doc-sidebar px-3 overflow-scroll d-none d-xl-block"
            style={{ zIndex: 1, padding: 65, height: "100vh" }}
          >
            {this.componentMenu()}
          </div>
        </div>
        {/* BODY */}
        {section && (
          <DocSection title={section.title}>
            <section.Component />
          </DocSection>
        )}
        {selected && typeof selected === "object" && (
          <DocSection
            title={selected.name || "Document API"}
            eyebrow={`${selected.request?.method?.toUpperCase() || "API"} · API Reference`}
          >
            <ApiReference
              selected={selected}
              type={type}
              responseTab={response_tab}
              onType={(value) => this.setState({ type: value })}
              onResponseTab={(index) => this.setState({ response_tab: index })}
            />
          </DocSection>
        )}
      </div>
    );
  }
}
